import React, { useMemo } from "react";
import { Col, Input, Label, Row } from "reactstrap";
import { getHolidayYears } from "../utils/holidayYears";

const MONTHS = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

export type HolidayListFiltersProps = {
  year: number;
  onYearChange: (year: number) => void;
  month: number | null;
  onMonthChange: (month: number | null) => void;
};

export default function HolidayListFilters({
  year,
  onYearChange,
  month,
  onMonthChange,
}: HolidayListFiltersProps) {
  const years = useMemo(() => getHolidayYears(), []);

  return (
    <Row className="g-2 g-md-3 align-items-end flex-grow-1 w-100 mb-0">
      <Col xs={12} sm="auto" md="auto" className="min-w-0">
        <Label
          className="form-label text-muted small mb-1"
          htmlFor="holiday-list-month"
        >
          Month
        </Label>
        <Input
          id="holiday-list-month"
          name="month"
          type="select"
          className="form-select"
          style={{ minWidth: "8rem" }}
          value={month ?? ""}
          onChange={(e) =>
            onMonthChange(e.target.value ? Number(e.target.value) : null)
          }
          aria-label="Filter holidays by month"
        >
          <option value="">All months</option>
          {MONTHS.map((name, i) => (
            <option key={i + 1} value={i + 1}>
              {name}
            </option>
          ))}
        </Input>
      </Col>
      <Col xs={12} sm="auto" md="auto" className="min-w-0">
        <Label
          className="form-label text-muted small mb-1"
          htmlFor="holiday-list-year"
        >
          Year
        </Label>
        <Input
          id="holiday-list-year"
          name="year"
          type="select"
          className="form-select"
          style={{ minWidth: "7rem" }}
          value={year}
          onChange={(e) => onYearChange(Number(e.target.value))}
          aria-label="Filter holidays by calendar year"
        >
          {years.map((y) => (
            <option key={y} value={y}>
              {y}
            </option>
          ))}
        </Input>
      </Col>
    </Row>
  );
}
